import { KeyboardEvent } from 'react';
import type { CommonHTMLLIAttributes } from '@frontend/types';
import { Text } from '../text/text.component';
import { FlyoutMenuItemStyles } from './flyout-menu-item.styles';
import { FlyoutMenuAction } from './types';

type Props = FlyoutMenuAction & CommonHTMLLIAttributes;

export const FlyoutMenuItem = ({ Icon, onClick, onKeyDown, label, trackingId, disabled = false }: Props) => {
  const liStyle = FlyoutMenuItemStyles.liStyle({ disabled });
  const iconStyle = FlyoutMenuItemStyles.iconStyle;

  return (
    <Text
      as='li'
      size='large'
      color='default'
      className={liStyle}
      onClick={onClick}
      onKeyDown={(event: KeyboardEvent) => onKeyDown!(event, disabled)}
      role='menuitem'
      tabIndex={-1}
      data-trackingid={trackingId}
    >
      {!!Icon && <Icon className={iconStyle} />}
      {label}
    </Text>
  );
};
